import React from "react";

import { INDUSTRY_HUB_TITLE } from "../constants";
import {
  ItemText,
  ListTitle,
  MenuList,
  MultiLevelMenu
} from "../MultiLevelMenu";

const IndustryHub = () => (
  <MultiLevelMenu title={INDUSTRY_HUB_TITLE}>
    <ListTitle>{INDUSTRY_HUB_TITLE}</ListTitle>
    <MenuList isSubMenu>
      <li>
        <ItemText href="/">Home</ItemText>
      </li>
      <li>
        <ItemText href="/blog/industry-hub/real-estate-tips/">
          Real Estate Tips
        </ItemText>
      </li>
      <li>
        <ItemText href="/blog/industry-hub/building-your-brand/">
          Building Your Brand
        </ItemText>
      </li>
      <li>
        <ItemText href="/blog/industry-hub/industry-events/">
          Industry Events
        </ItemText>
      </li>
    </MenuList>
  </MultiLevelMenu>
);

IndustryHub.propTypes = {};

IndustryHub.defaultProps = {};

export default IndustryHub;
